import type { ISerialize } from '@/objects/ISerialize';

export class SignalrStatusLoaderStatusParameters implements ISerialize {
    public UserID: number;

    /***
     * @deprecated Use the static FromJsValues method instead of the constructor to get type safety and default values
     */
    public constructor(values: { UserID?: number }) {
        this.UserID = values.UserID ?? 0;
    }

    public serialize(): string {
        return '{' + `"UserID": ${JSON.stringify(this.UserID)}` + '}';
    }

    /**
     * Creates an instance of SignalrStatusLoaderStatusParameters from the supplied values.
     * Missing values have default values
     * @param values The values you want to set
     * @returns An object instance with the supplied values set
     */
    public static FromJsValues(values: { UserID?: number }): SignalrStatusLoaderStatusParameters {
        return new SignalrStatusLoaderStatusParameters(values);
    }

    public static _FromServerJson(json: any): SignalrStatusLoaderStatusParameters {
        return new SignalrStatusLoaderStatusParameters({ UserID: json.UserID });
    }

    /**
     * Creates an instance of SignalrStatusLoaderStatusParameters from another instance of SignalrStatusLoaderStatusParameters.
     * @param other The SignalrStatusLoaderStatusParameters you want to clone
     * @returns A cloned SignalrStatusLoaderStatusParameters
     */
    public static FromOther(other: SignalrStatusLoaderStatusParameters): SignalrStatusLoaderStatusParameters {
        return SignalrStatusLoaderStatusParameters._FromServerJson(JSON.parse(other.serialize()));
    }

    /**
     * Deepclones the object.
     */
    public DeepClone() {
        return SignalrStatusLoaderStatusParameters.FromOther(this);
    }

    static NAME_OF_CLASS = 'SignalrStatusLoaderStatusParameters';
}
